import { useEffect } from "react";

const SITE = "CARIO Mail";

function meta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) { el = document.createElement("meta"); el.setAttribute(attr, key); document.head.appendChild(el); }
  el.setAttribute("content", content);
}

function link(rel, href) {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) { el = document.createElement("link"); el.setAttribute("rel", rel); document.head.appendChild(el); }
  el.setAttribute("href", href);
}

function jsonLd(data) {
  let el = document.getElementById("seo-jsonld");
  if (!el) { el = document.createElement("script"); el.type = "application/ld+json"; el.id = "seo-jsonld"; document.head.appendChild(el); }
  el.textContent = JSON.stringify(data);
}

// Sets title, description, canonical, social tags and structured data for the current page.
export function useSeo({ title, description, path, faq, article, noindex, alternates }) {
  useEffect(() => {
    const origin = window.location.origin;
    const url = origin + (path || window.location.pathname);
    document.title = title.includes(SITE) ? title : `${title} | ${SITE}`;
    meta("name", "description", description);
    meta("name", "robots", noindex ? "noindex,nofollow" : "index,follow,max-image-preview:large");
    meta("property", "og:title", document.title);
    meta("property", "og:description", description);
    meta("property", "og:url", url);
    meta("property", "og:type", article ? "article" : "website");
    meta("name", "twitter:title", document.title);
    meta("name", "twitter:description", description);
    link("canonical", url);
    document.head.querySelectorAll('link[rel="alternate"][hreflang]').forEach((el) => el.remove());
    Object.entries(alternates || {}).forEach(([lg, p]) => {
      const el = document.createElement("link");
      el.rel = "alternate"; el.hreflang = lg; el.href = origin + p;
      document.head.appendChild(el);
    });
    const graph = [{ "@type": "Organization", "@id": `${origin}/#org`, name: SITE, url: origin, logo: `${origin}/icons/icon-512.png` },
      { "@type": "WebSite", "@id": `${origin}/#site`, name: SITE, url: origin, publisher: { "@id": `${origin}/#org` } }];
    if (path === "/") graph.push({ "@type": "SoftwareApplication", name: SITE, applicationCategory: "BusinessApplication", operatingSystem: "Web",
      description, offers: { "@type": "Offer", price: "0", priceCurrency: "EUR" } });
    if (faq) graph.push({ "@type": "FAQPage", mainEntity: faq.map(([q, a]) => ({ "@type": "Question", name: q, acceptedAnswer: { "@type": "Answer", text: a } })) });
    if (article) graph.push({ "@type": "Article", headline: title, description, datePublished: article.published, dateModified: article.modified || article.published,
      inLanguage: article.lang, author: { "@id": `${origin}/#org` }, publisher: { "@id": `${origin}/#org` }, mainEntityOfPage: url });
    jsonLd({ "@context": "https://schema.org", "@graph": graph });
  }, [title, description, path, faq, article, noindex, alternates]);
}
